import { Link } from "react-router-dom";

const siteLinks = [
  { label: "首页", to: "/" },
  { label: "本周新番", to: "/series" },
  { label: "追番日历", to: "/calendar" },
  { label: "关于我们", to: "/about" },
];

const categoryLinks = ["热血", "奇幻", "恋爱", "悬疑", "搞笑", "日常", "科幻"];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-primary-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/15 text-background-50">
                <i className="ri-goblet-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-background-50">妖精动漫网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
              妖精动漫网专注新番更新追踪与追番日历，汇总本周新番、连载动漫与完结动漫动态。分类清晰、更新及时，打开妖精动漫网即可发现更多精彩作品，追更体验直接拉满。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-weibo-line", "ri-bilibili-line", "ri-tv-2-line", "ri-mail-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  aria-label="社交链接"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-primary-100 transition-colors hover:bg-primary-700"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold tracking-wide text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {siteLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-200 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold tracking-wide text-background-50">热门分类</h4>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {categoryLinks.map((c) => (
                <li key={c}>
                  <Link
                    to={`/series?cat=${encodeURIComponent(c)}`}
                    className="text-sm text-primary-200 transition-colors hover:text-background-50"
                  >
                    {c}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-primary-800 pt-6 sm:flex-row">
          <p className="text-xs text-primary-300">
            © {new Date().getFullYear()} 妖精动漫网 · 陪你追更每一天
          </p>
          <p className="text-xs text-primary-300">
            联系邮箱：support@yaojing-anime.com
          </p>
        </div>
      </div>
    </footer>
  );
}